<template>
  <section class="login">
      <div class="login--form">
          <form @submit.prevent="login">
            <img :src="require('@/assets/img/ic-logo.png')" alt="Upmood Logo">
            <h1>Login Account</h1>
            <p>This is a secure system and you will need to provide your login details to access the site.</p>

            <AppTextField
				v-model.trim="loginForm.email"
				placeholder="Email Address"
                :error="credentialError || emailError"
                :disabled="loginForm.loading"
			/>

            <AppTextField
				v-model="loginForm.password"
				placeholder="Password"
                type="password"
                :error="passwordError"
                :disabled="loginForm.loading"
			/>

           <AppButton modifier="large-primary" :disabled="loginForm.loading">
				<template v-if="loginForm.loading">
                    <AppLoading />
                </template>
				<template v-else>Sign In</template>
			</AppButton>
          </form>
      </div>

      <div class="login--bg"></div>
  </section>
</template>

<script>
import AppTextField from '@/components/AppTextField'
import AppButton from '@/components/AppButton'
import AppLoading from '@/components/AppLoading'
import { validateEmail, errorMessage } from '@/utils/helpers'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

export default {
	methods: {
		async login () {
			this.loginForm.errors = { email: [], password: [] }
			if (this.validate()) {
				const form = new FormData()
				form.set('email', this.loginForm.email.toLowerCase())
				form.set('password', this.loginForm.password)
				const isSuccess = await this.$store.dispatch('login', form)
				isSuccess && this.$router.go()
			}
		},

		validate () {
			const { email, password } = this.loginForm

			!email && (this.loginForm.errors.email = errorMessage.required('Email Address'))
			email && !validateEmail(email) && (this.loginForm.errors.email = errorMessage.invalidEmail)
			!password && (this.loginForm.errors.password = errorMessage.required('Password'))

			return !(this.loginForm.errors.email.length || this.loginForm.errors.password.length)
		}
	},
	computed: {
		...mapFields(['loginForm']),
		...mapGetters(['emailError', 'passwordError', 'credentialError'])
	},
	components: {
		AppTextField,
		AppButton,
		AppLoading
	}
}
</script>

<style lang="scss" scoped>
.login {
    @include flex-row;

    /deep/ .app-loading {
        height: 20px;

		span {
            height: 16px;
		    width: 16px;
        }
	}

    /deep/ .app-text-field {
        font-size: 1.6em;
        margin: 16px 0;
        width: 100%;

        &__input {
            padding: 12px 5px;
        }

        &__error {
            font-size: .6em;
        }

        &__toggle {
            font-size: .6em;
        }
    }

    button {
        padding: 16px 0;
        width: 100%;
        font-size: 1.4em;
        margin-top: 20px;
    }

    &--form {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        height: 100vh;
    }

    form {
        @include flex-column;
        align-items: center;
        justify-items: center;
        padding: 0 8px;
    }

    h1 {
        font-size: 2.8em;
        font-weight: normal;
        margin: 32px 0 24px 0;
    }

    p {
        font-size: 1.4em;
        max-width: 300px;
        text-align: center;
        opacity: .7;
    }

    a.login--link {
        font-size: 1.2em;
        color: #F2134F;
        align-self: flex-end;
    }

    span {
        font-size: 1.2em;
        align-self: flex-start;
        margin-top: 20px;
    }

    &--bg {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url('~@/assets/img/login-bg.png');
        height: 100vh;
        width: 100vw;
        flex-basis: 50%;

          @media (max-width: 768px) {
            display: none;
        }
    }
}
</style>
